// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"800":"24ab377c","926":"72c0891a"}[chunkId] + ".chunk.css";
};